import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { IconDownloadOutline, mediaBreakpointMixin, Spacer, TextButton, token } from '@zillow/constellation';
import { PRINT_APPLICATION_QUERY } from '../../../constants/queries';
import useQueryVariables from '../../../hooks/useQueryVariables';
import { getPrintApplicationPath } from '../../../constants/urls';
import { doesLandlordHavePermissionsForAllApplicants } from '../../../utils/pdf-permissions';
import { getGlobalMonitor } from '@zg-rentals/monitor-base';

const StyledSpacer = styled(Spacer)`
  border-top: 1px solid ${token('colors.borderLight')};

  @media ${mediaBreakpointMixin('lg')} {
    border-top: none;
  }
`;

function DownloadApplicationButton() {
  const { propertyId, applicationId } = useQueryVariables();
  const options = { listingAlias: propertyId, applicationId };
  const { data, loading, error } = useQuery(PRINT_APPLICATION_QUERY, { variables: options });
  const downloadPath = getPrintApplicationPath(propertyId, applicationId);

  const onPrint = () => {
    setTimeout(() => {
      getGlobalMonitor()?.count({ name: 'downloadApplicationButtonClicked' });
      window.open(downloadPath, '_blank').print();
    }, 100);
  };

  return (
    !loading &&
    !error &&
    doesLandlordHavePermissionsForAllApplicants(data) && (
      <StyledSpacer paddingTop={{ default: 'md', lg: 0 }}>
        <TextButton as="a" icon={<IconDownloadOutline />} onClick={onPrint} role="link">
          Download PDF
        </TextButton>
      </StyledSpacer>
    )
  );
}

export default DownloadApplicationButton;
